import React from "react";
import { FloatingButton, WhatsAppIcon } from "./WhatsAppButton.style";

const WhatsAppButton = () => {
  const phoneNumber = "2348034231676"; // Format: country code + number without +
  const message = encodeURIComponent(
    "Hello! I'm interested in learning more about your solar and security solutions."
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <FloatingButton
      href={whatsappUrl}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <WhatsAppIcon viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm5.71 13.88c-.24.68-1.37 1.37-1.89 1.46-.51.1-.99.23-3.26-.69-2.76-1.12-4.52-4.01-4.66-4.2-.13-.18-1.11-1.48-1.11-2.82 0-1.34.79-2.01.97-2.25.18-.24.43-.3.57-.25.14.05.86.35.99.87.13.52.43 1.62.53 1.89.1.27.02.55-.13.73-.09.11-.21.28-.31.42-.1.14-.2.27-.26.36-.09.13-.17.24-.12.47.05.24.24 1.06.79 1.74.55.68 1.28 1.12 1.61 1.24.33.13.52.11.71-.06.2-.18.81-.94 1.03-1.27.22-.33.44-.27.59-.21.15.05.96.45 1.12.53.17.09.28.13.32.2.05.08.05.46-.19 1.13z"/>
      </WhatsAppIcon>
    </FloatingButton>
  );
};

export default WhatsAppButton;
